import { InjectionToken } from '@angular/core';

/**
 * Abstraktion der App-Navigation, die der Header benötigt.
 * Die App überschreibt den Token mit der konkreten Implementierung (PageService);
 * der Default ist wirkungslos (greift z.B. in Tests ohne App-Provider).
 */
export interface IPageNav {
  toggleMenu(): void;
  returnToPreviousPage(): void;
}

export const PAGE_NAV = new InjectionToken<IPageNav>('PAGE_NAV', {
  providedIn: 'root',
  factory: () => ({
    toggleMenu: () => undefined,
    returnToPreviousPage: () => undefined,
  }),
});
